import React from "react";
import { ReactTypeformEmbed } from "react-typeform-embed";

export const TypeFormWrapper = ({ onSubmit, surveyUrl }) => {
  return <ReactTypeformEmbed url={surveyUrl} onSubmit={onSubmit} autoClose />;
};
